import { convertToRaw, EditorState } from "draft-js";
import { useState, Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./textEditor.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

export function TextEditor(props) {
  // onChange = (content) => {
  //   console.log("onChange", content);
  // };
  // const { editorState } = this.state;
  // const [editorState, setEditorState] = useState(EditorState.createEmpty());
  // const [text, setText] = useState();
  // const onEditorStateChange = function (editorState) {
  //   //   setEditorState(editorState);
  //   //   const { blocks } = convertToRaw(editorState.getCurrentContent());

  //   let text = draftToHtml(convertToRaw(editorState.getCurrentContent()));
  //   console.log(text);
  //   //   setText(text);
  // };
  // const blockRenderMap = Immutable.Map({
  //   'unordered-list-item': {
  //     element: 'li',
  //     wrapper: 'type="1"'
  //   },
  //   'ordered-list-item': {
  //     element: 'li',
  //     wrapper: 'type="1"'
  //   },
  // });

  return (
    <>
      {/*<div>{draftToHtml(convertToRaw(editorState.getCurrentContent()))}</div>*/}
      {/* {<div style={{ height: "80px", overflow: "auto" }}>{text}</div>} */}
      <Editor
        //   editorState={editorState}
        //   toolbarClassName="toolbarClassName"
        toolbar={{
          options: [
            "inline",
            "blockType",
            "fontSize",
            "list",
            "textAlign",
            "remove",
            "history",
          ],
        }}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        onEditorStateChange={props.onChange}
      />
    </>
  );
}
